const factory = (benchLocation, config, Model, Api) => {
  class FdsConnection extends Model {
    $getPlaidLinkToken(clientId, connectionId = '') {
      const { vendor } = config;
      const originUri = vendor && vendor.plaid && vendor.plaid.origin_uri;
      const params = {};
      if (connectionId) {
        params.connectionId = connectionId;
      }
      if (originUri) {
        params.originUri = originUri;
      }
      return this.$apiCall({
        url: `client/${clientId}/createLinkToken`,
        method: 'GET',
        params,
      });
    }
  }

  FdsConnection.prototype.$idName = 'id';
  FdsConnection.prototype.id = null;
  FdsConnection.prototype.ledgers = null;
  FdsConnection.prototype.$apiService = new Api('fds');

  // Currently this doesn't have any methods per connection. But creating stub here

  return FdsConnection;
};

const moduleDeps = [require('data/util').name, require('angular-ui-router')];

module.exports = angular
  .module('bench.data.model.fdsConnection', moduleDeps)
  .factory('FdsConnectionModel', factory);
